/**
 * outboxTelemetry — une file d'envoi qui parle à la télémétrie commune du moteur : ses fils d'Ariane
 * et ses erreurs partent dans le Bugsnag de la plateforme, avec la machine, le rôle et la plateforme,
 * les clés qui porteraient un nom retirées (`cleanMetadata`). Jamais d'id ni de nom dans un message.
 */
import { Platform } from "react-native"

import { type TelemetryRole } from "../telemetry"
import { type TelemetryClient } from "../telemetryClient"
import { cleanMetadata, type TelemetryData } from "../telemetryMetadata"
import { type OutboxTelemetry, type OutboxTelemetryMetadata } from "./outbox"

/** Les métadonnées aplaties en valeurs simples (le fil des transitions en une ligne). */
function flatten(metadata: OutboxTelemetryMetadata | undefined): TelemetryData {
    const flat: TelemetryData = {}
    for (const [key, value] of Object.entries(metadata ?? {})) {
        flat[key] = Array.isArray(value) ? value.join(" | ") : value
    }
    return flat
}

export function engineOutboxTelemetry(machine: string, role: TelemetryRole, client?: TelemetryClient): OutboxTelemetry {
    const context = { machine, role, platform: Platform.OS }
    // Bugsnag se charge au premier envoi, pas à l'import : `@bugsnag/expo` lit le natif en se chargeant.
    const target = (): TelemetryClient =>
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        client ?? (require("../bugsnagClient") as { bugsnagClient: TelemetryClient }).bugsnagClient
    return {
        breadcrumb: (message, metadata) =>
            target().leaveBreadcrumb(message, { ...cleanMetadata(flatten(metadata)), ...context }),
        error: (error, metadata) =>
            target().notify(error, {
                context: `engine/${machine}`,
                severity: "error",
                section: "engine",
                metadata: { ...cleanMetadata(flatten(metadata)), ...context },
            }),
    }
}
